import { render, staticRenderFns } from "./FlyerSlider.vue?vue&type=template&id=61b1a798"
import script from "./FlyerSlider.vue?vue&type=script&lang=js"
export * from "./FlyerSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports